import { RRule, RRuleSet } from "rrule"
const moment = require("moment-timezone")
function returnFinalFormattedDate(momentDate, hours) {
  if (hours === "0:0" || hours === "23:59") {
    return momentDate.format("DD/MM/YY")
  }
  return momentDate.format("DD/MM/YY à HH:mm")
}

function getHours(date) {
  const hours = date.getHours()
  const seconds = date.getSeconds()
  return hours + ":" + seconds
}

function excludeDates(exdateLine, rrule) {
  const exdateString = exdateLine?.replace("EXDATE:", "").trim()

  const exdates =
    exdateString?.split(",").map((date) => {
      const formattedDateString = date.replace(
        /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/,
        "$1-$2-$3T$4:$5:$6Z"
      )
      return new Date(formattedDateString)
    }) || []

  exdates.forEach((exdate) => {
    rrule.exdate(exdate)
  })
  return rrule
}
function getRecurrenceDate(
  rruleString,
  dateRecurrenteValue,
  dateRecurrenteEndValue,
  infinite
) {
  const startValue = new Date(dateRecurrenteValue)
  const endValue = new Date(dateRecurrenteEndValue)
  const interval = endValue - startValue
  const today = new Date()
  const [rruleLine, exdateLine] = rruleString.split("\n")
  const origOptions = RRule.fromString(rruleLine).origOptions
  let rrule = new RRuleSet()
  rrule.rrule(RRule.fromString(rruleLine))
  // Gestion des dates exclus
  // =============================================================

  let date = null
  if (infinite) {
    rrule = excludeDates(exdateLine, rrule)
    date = rrule.all()
    date = date[0]
  } else {
    let notInfiniteRrule = new RRuleSet()
    notInfiniteRrule.rrule(
      new RRule({
        ...origOptions, // On reprend toutes les options existantes
        dtstart: startValue, // On modifie uniquement la date de début
      })
    )
    notInfiniteRrule = excludeDates(exdateLine, notInfiniteRrule)
    const dates = notInfiniteRrule.all()
    for (let iterate = 0; iterate < dates.length; iterate++) {
      if (dates[iterate] >= today) {
        date = dates[iterate]
        break
      }
    }
    if (date === null) {
      date = dates[dates.length - 1]
    }
  }

  date.setHours(
    startValue.getHours(),
    startValue.getMinutes(),
    startValue.getSeconds(),
    startValue.getMilliseconds()
  )
  const startMoment = moment(date)
  const formattedStartMoment = returnFinalFormattedDate(
    startMoment,
    getHours(date)
  )
  const endDate = new Date(date.getTime() + interval)
  const endMoment = moment(endDate)
  const formattedEndMoment = returnFinalFormattedDate(
    endMoment,
    getHours(endDate)
  )
  const isOnOneDay = formattedStartMoment === formattedEndMoment
  return {
    value: date,
    endValue: isOnOneDay ? null : endDate,
    formattedStartMoment: formattedStartMoment,
    formattedEndMoment: isOnOneDay ? null : formattedEndMoment,
    year: date.getFullYear(),
  }
}
export function setRecurringEventDates(data, isDetails = false) {
  if (isDetails) {
    const newNode = data
    if (newNode.field_evenement_recurrent) {
      const dates = getRecurrenceDate(
        newNode.field_date_recurrente.rrule,
        newNode.fields.formatted_for_compare_field_date_recurrente_value,
        newNode.fields.formatted_for_compare_field_date_recurrente_end_value,
        newNode.field_date_recurrente.infinite
      )
      newNode.field_date_de_debut = dates.formattedStartMoment
      newNode.field_date_de_fin = dates.formattedEndMoment
      newNode.fields.formatted_field_date_de_debut = dates.formattedStartMoment
      newNode.fields.formatted_field_date_de_fin = dates.formattedEndMoment
      newNode.year = dates.year
      return newNode
    }
  } else {
    const newData = data.allNodeEvenements.edges.map((node) => {
      const newNode = { ...node }
      if (newNode.node.field_evenement_recurrent) {
        const dates = getRecurrenceDate(
          newNode.node.field_date_recurrente.rrule,
          newNode.node.fields.formatted_for_compare_field_date_recurrente_value,
          newNode.node.fields
            .formatted_for_compare_field_date_recurrente_end_value,
          newNode.node.field_date_recurrente.infinite
        )
        newNode.node.field_date_de_debut = dates.formattedStartMoment
        newNode.node.field_date_de_fin = dates.formattedEndMoment
        newNode.node.fields.formatted_field_date_de_debut =
          dates.formattedStartMoment
        newNode.node.fields.formatted_field_date_de_fin =
          dates.formattedEndMoment
        newNode.node.fields.formatted_for_compare_field_date_de_debut =
          dates.value
        newNode.node.fields.formatted_for_compare_field_date_de_fin =
          dates.endValue
        newNode.node.year = dates.year
      }

      return newNode
    })
    return newData
  }
  return data
}
